import { Document, Page, Text, View, Font, Image } from "@react-pdf/renderer"
import { Header, Table, Footer } from "../index"
import intl from "react-intl-universal"

/* FONTS */
import sourceSansProRegular from "../../../../../../../assets/fonts/sourceSansPro/SourceSansPro-Regular.ttf"
import sourceSansProSemiBold from "../../../../../../../assets/fonts/sourceSansPro/SourceSansPro-Semibold.ttf"
import sourceSansProBold from "../../../../../../../assets/fonts/sourceSansPro/SourceSansPro-Bold.ttf"
import sourceSansProItalic from "../../../../../../../assets/fonts/sourceSansPro/SourceSansPro-Italic.ttf"
import sourceSansProSemiBoldItalic from "../../../../../../../assets/fonts/sourceSansPro/SourceSansPro-SemiboldItalic.ttf"
import sourceSansProBoldItalic from "../../../../../../../assets/fonts/sourceSansPro/SourceSansPro-BoldItalic.ttf"

import poppinsRegular from "../../../../../../../assets/fonts/poppins/Poppins-Regular.ttf"
import poppingsMedium from "../../../../../../../assets/fonts/poppins/Poppins-Medium.ttf"
import poppinsSemiBold from "../../../../../../../assets/fonts/poppins/Poppins-SemiBold.ttf"
import poppinsBold from "../../../../../../../assets/fonts/poppins/Poppins-Bold.ttf"
import poppinsItalic from "../../../../../../../assets/fonts/poppins/Poppins-Italic.ttf"
import poppinsMediumItalic from "../../../../../../../assets/fonts/poppins/Poppins-MediumItalic.ttf"
import poppinsSemiBoldItalic from "../../../../../../../assets/fonts/poppins/Poppins-SemiBoldItalic.ttf"
import poppinsBoldItalic from "../../../../../../../assets/fonts/poppins/Poppins-BoldItalic.ttf"
import { stylesPDF } from "./styles"

Font.register({
  family: "Source Sans Pro",
  fonts: [
    { src: sourceSansProRegular, fontWeight: 400, fontStyle: "normal" },
    { src: sourceSansProRegular, fontWeight: 500, fontStyle: "normal" },
    { src: sourceSansProSemiBold, fontWeight: 600, fontStyle: "normal" },
    { src: sourceSansProBold, fontWeight: 700, fontStyle: "normal" },
    { src: sourceSansProItalic, fontWeight: 400, fontStyle: "italic" },
    { src: sourceSansProItalic, fontWeight: 500, fontStyle: "italic" },
    { src: sourceSansProSemiBoldItalic, fontWeight: 600, fontStyle: "italic" },
    { src: sourceSansProBoldItalic, fontWeight: 700, fontStyle: "italic" },
  ],
})

Font.register({
  family: "Poppins",
  fonts: [
    { src: poppinsRegular, fontWeight: 400, fontStyle: "normal" },
    { src: poppingsMedium, fontWeight: 500, fontStyle: "normal" },
    { src: poppinsSemiBold, fontWeight: 600, fontStyle: "normal" },
    { src: poppinsBold, fontWeight: 700, fontStyle: "normal" },
    { src: poppinsItalic, fontWeight: 400, fontStyle: "italic" },
    { src: poppinsMediumItalic, fontWeight: 500, fontStyle: "italic" },
    { src: poppinsSemiBoldItalic, fontWeight: 600, fontStyle: "italic" },
    { src: poppinsBoldItalic, fontWeight: 700, fontStyle: "italic" },
  ],
})

const CiqReportPdf = ({ listAnalytes, generateReport }) => {
  if (!listAnalytes?.length) {
    return (
      <Document>
        <Page size="A4" style={stylesPDF.page}>
          <Header customer={generateReport.customer} report={generateReport} />
        </Page>
      </Document>
    )
  }

  const fnGetAnalyteEquipment = (analyte) => {
    let oEquipment = null
    generateReport?.equipment?.forEach((equipment) => {
      equipment.equipment_analytes.forEach((item) => {
        if (item.eqpanlt_anlt_nid === analyte.eqpanlt_anlt_nid) {
          oEquipment = equipment
        }
      })
    })

    return oEquipment
  }

  return (
    <Document>
      {listAnalytes.map((item, index) => (
        <Page size="A4" style={stylesPDF.page} key={`ciq-report-analyte-${index}`}>
          <Header customer={generateReport.customer} report={generateReport} />
          <Text style={stylesPDF.sectionTitle}>{`${
            fnGetAnalyteEquipment(item)?.equipment_cname
          } - ${item.eqpanlt_anlt.anlt_cname}`}</Text>
          {!item?.runs?.length && (
            <Text style={stylesPDF.noRuns}>{intl.get("ciqReport.pdf.no_runs")}</Text>
          )}

          {item?.runs?.length && (
            <>
              {item.runs.map((run, index) => (
                <Table
                  key={`cir-report-run-card-${index}`}
                  unitOfMeasure={item.eqpanlt_anlt.anlt_unit_of_measure}
                  run={run}
                  analyteType={item.eqpanlt_anlt.anlt_type}
                />
              ))}
            </>
          )}

          {item?.componentsBase64?.length && (
            <>
              {item?.componentsBase64?.map((chart, index) => (
                <View
                  key={`ciq-report-components-base64-container-${item.eqpanlt_anlt.anlt_nid}-${index}`}
                  style={stylesPDF.chartContainer}
                  wrap={false}
                >
                  <View style={stylesPDF.chartTitleContainer}>
                    <Text style={stylesPDF.chartTitleText}>
                      {item?.eqpanlt_anlt?.anlt_type === "Quantitativo"
                        ? intl.get("ciqReport.pdf.levey_jennings_chart")
                        : intl.get("ciqReport.pdf.result_table")}
                    </Text>
                  </View>
                  <View style={stylesPDF.chart}>
                    <Image src={chart} />
                  </View>
                </View>
              ))}
            </>
          )}
          <Footer user={generateReport.user} />
        </Page>
      ))}
    </Document>
  )
}

export default CiqReportPdf
